class ContactSocialController {
    private onUpdate: any;
    private contact: any;

    constructor(private $state: ng.ui.IStateService) {
        'ngInject';       
        // console.log('ContactBasicInfoController');
    }

    submitSocialForm() {
        // console.log('update ContactBasicInfo');

        this.onUpdate({contact: this.contact});

        (<any>$('#contactSocialModal')).modal('hide');
    }
}

export const contactSocialComponent = {
    bindings: {
        contact: '<',
        onUpdate: "&"
    },
    controller: ContactSocialController,
    template: require('./contactSocialModal.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/contacts/contactSocialModal.component.ts